import React, { memo, useCallback, useState } from 'react';

import { AutoComplete, AutoCompleteProps } from 'antd';
import { DefaultOptionType } from 'antd/es/select';

import { includes, toLower } from 'ramda';

export type SelectFormData = {
	value: string;
	name: string;
	index?: number;
};

export type AutoCompleteFormProps = AutoCompleteProps & {
	containerClassName?: string;
	boxStyle?: React.CSSProperties;
	name: string;
	onChange?: (data: SelectFormData) => void;
	index?: number;
};

const AutoCompleteForm = ({
	containerClassName,
	boxStyle,
	onChange,
	name,
	index,
	...rest
}: AutoCompleteFormProps) => {
	const [options, setOptions] = useState<DefaultOptionType[] | undefined>(
		rest.options
	);
	const _onChange = useCallback(
		(value: string) => {
			onChange?.({
				value,
				name,
				index,
			});
		},
		[name, onChange]
	);
	const onSearch = useCallback(
		(searchText: string) => {
			const _result = rest.options?.filter((item) =>
				includes(toLower(searchText), toLower(item?.label as string))
			);

			setOptions(_result);
		},
		[rest.options]
	);
	return (
		<div className={containerClassName} style={boxStyle}>
			<AutoComplete
				{...rest}
				style={{ width: '100%', height: '100%' }}
				onChange={_onChange}
				className="!border-none bg-transparent focus:bg-transparent hover:bg-transparent focus-within:bg-transparent [&>.ant-select-selector]:!border-none"
				onSearch={onSearch}
				options={options}
			/>
		</div>
	);
};

export default memo(AutoCompleteForm);
